import RewriteCCRender from './index.vue'

RewriteCCRender.install = function (Vue, options) {
    Vue.component(`rewrite-cc-render`, RewriteCCRender)
}

export default RewriteCCRender
